import React from "react";
import {axiosCommon} from "../../../util/axiosSetup.js";
import {BASE_URL} from "../../../util/Urls";
import NavHeader from "../../../components/NavHeader";
import Footer from "../../../components/Footer";
import {Checkbox, FormControlLabel, IconButton, TextField, Toolbar, Tooltip, Typography} from "@material-ui/core";
import ClearIcon from "@material-ui/icons/Clear";
import {TextValidator, ValidatorForm} from "react-material-ui-form-validator";
import Widget from "../../../components/Widget";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Card from "../../../components/Card";
import SaveCancelButtons from "../../../components/SaveCancelButtons";

export default class EditKitchenDisplay extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            kitchenDisplay: {
                name: null,
                ipAddress: null,
                isMainKitchenDisplay: false,
                ticketMergeThresholdSeconds: 60,
                minutesAfterTurningYellow: 15,
                minutesAfterTurningRed: 25,
            },
            shopOptions: [],
            selectedShopOption: null,
            wasMainKitchenDisplay: false,
            isSubmitInProgress: false,
        };
    }

    componentDidMount() {
        axiosCommon.get(`${BASE_URL}/api/shops`)
            .then(response => {
                const shopOptions = response.data.items.map(c => {
                    return {label: c.name, value: c.id}
                });

                const selectedShopOption = this.props.location.shopId !== undefined
                    ? shopOptions.find(shop => shop.value == this.props.location.shopId)
                    : shopOptions[0] || undefined

                this.setState({
                    shopOptions,
                    selectedShopOption
                }, () => {
                    if (this.props.location.kitchenDisplayId) {
                        axiosCommon.get(`${BASE_URL}/api/kitchendisplay/${this.props.location.kitchenDisplayId}`)
                            .then(response => {
                                const selectedShopOption = shopOptions.find(shop => shop.value == response.data.shopId) || this.state.selectedShopOption;
                                this.setState({
                                    kitchenDisplay: response.data,
                                    wasMainKitchenDisplay: response.data.isMainKitchenDisplay === true,
                                    selectedShopOption,
                                })
                            })
                            .catch(error => {
                                this.setState({error});
                            });
                    }
                })
            })
    }

    onSubmit = () => {
        this.setState({isSubmitInProgress: true});

        const {kitchenDisplay} = this.state;
        kitchenDisplay.shopId = this.state.selectedShopOption.value;

        axiosCommon({
            method: this.props.location.kitchenDisplayId ? "put" : "post",
            url: `${BASE_URL}/api/kitchendisplay`,
            data: kitchenDisplay
        })
            .then(response => {
                this.goBack();
            })
            .catch(error => {
                this.setState({error, isSubmitInProgress: false});
            });
    };

    goBack = () => {
        this.props.history.goBack();
    }

    handleChange = (event) => {
        const {kitchenDisplay} = this.state;
        kitchenDisplay[event.target.name] = event.target.value;
        this.setState({kitchenDisplay});
    }

    handleShopChange = (event, value) => {
        this.setState({selectedShopOption: value});
    }

    renderEdit = () => {
        return <>
            <Toolbar className="mb-16 align-center justify-space-between">
                <Typography variant="h5" id="tableTitle" component="div">
                    {this.props.location.kitchenDisplayId ? "Konyhai kijelző szerkesztése" : "Új konyhai kijelző"}
                </Typography>
                <IconButton onClick={this.goBack}>
                    <ClearIcon fontSize="large"/>
                </IconButton>
            </Toolbar>

            <ValidatorForm onSubmit={this.onSubmit}>
                <Card title="Általános adatok">
                    <Widget>
                        <div className="flex-1">
                            <TextValidator
                                label="Név"
                                variant="outlined"
                                fullWidth
                                onChange={this.handleChange}
                                name="name"
                                value={this.state.kitchenDisplay.name || ""}
                                required
                                validators={['required']}
                                errorMessages={['A mező kitöltése kötelező']}
                            />
                        </div>
                        <div className="m-8"/>
                        <div className="flex-1">
                            <Autocomplete
                                onChange={this.handleShopChange}
                                disabled={this.props.location.kitchenDisplayId !== undefined}
                                name="shopId"
                                fullWidth
                                disableClearable
                                noOptionsText="Nincs ilyen tétel"
                                options={this.state.shopOptions}
                                getOptionLabel={(option) => option === "" ? "" : option.label}
                                getOptionSelected={(option, value) => option.value === value.value}
                                value={this.state.selectedShopOption || ""}
                                renderInput={(params) =>
                                    <TextField {...params} label="Üzlet" required variant="outlined"/>
                                }
                            />
                        </div>
                    </Widget>

                    <Widget>
                        <div className="flex-1">
                            <TextValidator
                                label="IP cím"
                                variant="outlined"
                                fullWidth
                                onChange={this.handleChange}
                                name="ipAddress"
                                value={this.state.kitchenDisplay.ipAddress || ""}
                                required
                                validators={['required', 'matchRegexp:^((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)\\.){3}(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)$']}
                                errorMessages={['A mező kitöltése kötelező', 'Adj meg érvényes IP cím (pl.: 192.168.1.10)']}
                            />
                        </div>
                        <div className="m-8"/>
                        <div className="flex-1">
                            <TextValidator
                                label="Tételek összevonási küszöb (mp)"
                                variant="outlined"
                                fullWidth
                                onChange={this.handleChange}
                                name="ticketMergeThresholdSeconds"
                                value={this.state.kitchenDisplay.ticketMergeThresholdSeconds ?? ""}
                                validators={['isNumber', 'minNumber:0']}
                                errorMessages={['A megadott érték nem szám', 'Az értéknek 0 vagy nagyobbnak kell lennie']}
                            />
                        </div>
                    </Widget>

                    <Widget>
                        <div className="flex-1">
                            <TextValidator
                                label="Sárga jelzés (perc)"
                                variant="outlined"
                                fullWidth
                                onChange={this.handleChange}
                                name="minutesAfterTurningYellow"
                                value={this.state.kitchenDisplay.minutesAfterTurningYellow ?? ""}
                                validators={['isNumber', 'minNumber:0']}
                                errorMessages={['A megadott érték nem szám', 'Az értéknek 0 vagy nagyobbnak kell lennie']}
                            />
                        </div>
                        <div className="m-8"/>
                        <div className="flex-1">
                            <TextValidator
                                label="Piros jelzés (perc)"
                                variant="outlined"
                                fullWidth
                                onChange={this.handleChange}
                                name="minutesAfterTurningRed"
                                value={this.state.kitchenDisplay.minutesAfterTurningRed ?? ""}
                                validators={['isNumber', 'minNumber:0']}
                                errorMessages={['A megadott érték nem szám', 'Az értéknek 0 vagy nagyobbnak kell lennie']}
                            />
                        </div>
                    </Widget>

                    <Tooltip title={this.state.wasMainKitchenDisplay
                        ? "A főkijelzőt közvetlenül nem lehet leváltani. Egy másik kijelzőn jelöld be a főkijelző mezőt a leváltáshoz."
                        : "Ha bejelölöd, ez a kijelző lesz a főkijelző, a jelenlegi főkijelző automatikusan leváltásra kerül."}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={this.state.kitchenDisplay.isMainKitchenDisplay || false}
                                    disabled={this.state.wasMainKitchenDisplay}
                                    onChange={(event) => {
                                        const {kitchenDisplay} = this.state;
                                        kitchenDisplay.isMainKitchenDisplay = event.target.checked;
                                        this.setState({kitchenDisplay});
                                    }}
                                    color="primary"
                                />
                            }
                            label="Főkijelző"
                        />
                    </Tooltip>
                </Card>

                <SaveCancelButtons
                    error={this.state.error}
                    isSubmitInProgress={this.state.isSubmitInProgress}
                    onCancel={() => this.props.history.goBack()}
                />
            </ValidatorForm>
        </>
    }

    render() {
        return <section className="main-content">
            <section className="main-content-body">
                <NavHeader changeSidebarToggled={this.props.changeSidebarToggled}/>
                {this.renderEdit()}
            </section>

            <Footer/>
        </section>;
    }
}
